import { render, staticRenderFns } from "./PsiDetailCoupons.vue?vue&type=template&id=5e9bfae9"
import script from "./PsiDetailCoupons.vue?vue&type=script&lang=js"
export * from "./PsiDetailCoupons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports